<!--
 * @Descripttion: 登录页面组件
 * @Author: congz
 * @Date: 2020-06-11 11:08:34
 * @LastEditors: congz
 * @LastEditTime: 2020-08-19 10:14:30
--> 

<template>
  <div class="login">
    <div>
      <el-card class="box-card" shadow="hover">
        <router-link class="login-logo-link" to="/">
          <img class="login-logo" src="../assets/imgs/clogo.png" alt />
        </router-link>
        <div class="clearfix">
          <span>Login</span>
        </div>
        <div class="item">
          <el-tabs v-model="activeTab" stretch>
            <el-tab-pane label="Password" name="password">
              <el-form :model="form" status-icon :rules="rules" ref="form">
                <el-form-item prop="user_name">
                  <el-input v-model="form.user_name" placeholder="Username"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input type="password" v-model="form.password" placeholder="Password"></el-input>
                </el-form-item>
                <el-form-item prop="captcha_value">
                  <el-input
                    v-model="form.captcha_value"
                    placeholder="Math Captcha Answer"
                    style="width:62%;float:left"
                  ></el-input>
                  <span
                    class="math-captcha"
                    @click="refreshCaptcha"
                  >{{captchaExpression}}</span>
                </el-form-item>
              </el-form>
              <div style="margin-top:15px">
                <a href="javascript:;" class="btn-gradient desert block" @click="login('form')">Login</a>
              </div>
            </el-tab-pane>
            <el-tab-pane label="OTP" name="otp">
              <el-form :model="otpForm" status-icon :rules="otpRules" ref="otpForm">
                <el-form-item prop="phone">
                  <el-input v-model="otpForm.phone" placeholder="Phone Number"></el-input>
                </el-form-item>
                <el-form-item prop="captcha_value">
                  <el-input
                    v-model="otpForm.captcha_value"
                    placeholder="Math Captcha Answer"
                    style="width:62%;float:left"
                  ></el-input>
                  <span
                    class="math-captcha"
                    @click="refreshCaptcha"
                  >{{captchaExpression}}</span>
                </el-form-item>
                <el-form-item prop="code">
                  <el-input
                    v-model="otpForm.code"
                    placeholder="Verification Code"
                    style="width:62%;float:left"
                  ></el-input>
                  <el-button
                    type="primary"
                    style="width:36%;float:right"
                    @click="sendCode"
                    :disabled="counting"
                  >{{codeText}}</el-button>
                </el-form-item>
              </el-form>
              <div style="margin-top:15px">
                <a href="javascript:;" class="btn-gradient desert block" @click="otpLogin('otpForm')">Login</a>
              </div>
            </el-tab-pane>
          </el-tabs>
          <el-link
            type="primary"
            href="/#/register"
            style="float:right;margin-bottom:10px;"
          >Don't have an account? Please register first ></el-link>
        </div>
        <div class="line"></div>
<!--        <div class="logo">-->
<!--          <div class="logo-info">其他账号登录:</div>-->
<!--          <div class="logo-login">-->
<!--            <div @click="qqInit">-->
<!--              <img src="../assets/imgs/QQlogo.png" alt />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as userAPI from '@/api/users'
export default {
  name: 'Login',
  data() {
    var validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('enter one user name'))
      } else if (value.length < 5 || value.length > 15) {
        callback(new Error('The username length should be between 5 and 15'))
      }
      callback()
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password'))
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('The password length should be between 8 and 16'))
      }
      callback()
    }
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter phone number'))
      } else if (value.length !== 10) {
        callback(new Error('Phone number must be 10 digits'))
      }
      callback()
    }
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter verification code'))
      } else if (value.length !== 6) {
        callback(new Error('Verification code must be 6 digits'))
      }
      callback()
    }
    return {
      activeTab: 'password',
      form: {
        user_name: '',
        password: '',
        captcha_id: '',
        captcha_value: ''
      },
      rules: {
        user_name: [{ validator: validateUser, trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }]
      },
      captchaId: '',
      captchaExpression: '',
      otpForm: {
        phone: '',
        captcha_value: '',
        code: ''
      },
      otpRules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        code: [{ validator: validateCode, trigger: 'blur' }]
      },
      counting: false,
      codeText: 'Get Code',
      totalTime: 60
    }
  },
  methods: {
    ...mapActions(['setUser']),
    login(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        this.form.captcha_id = this.captchaId
        userAPI
          .postLogin(this.form)
          .then(res => {
            if (res.status === 404) {
              this.notifyError('Verification failed', res.msg)
            } else if (res.status === 200) {
              // 登录信息存到本地
              let user = JSON.stringify(res.data.user)
              localStorage.setItem('user', user)
              localStorage.setItem('token', res.data.token)
              // 登录信息存到vuex
              this.setUser(res.data.user)
              // 弹出通知框提示登录成功信息
              this.notifySucceed('Login successful')
              this.$router.push({
                name: 'Home'
              })
            } else {
              // 登录失败刷新验证码
              this.refreshCaptcha()
              this.notifyError('Login failed', res.msg)
            }
          })
          .catch(error => {
            this.refreshCaptcha()
            this.notifyError('Login failed', error)
          })
      })
    },
    refreshCaptcha() {
      userAPI.getMathCaptcha().then(res => {
        if (res.status === 200) {
          this.captchaId = res.data.captcha_id
          this.captchaExpression = res.data.expression
        }
      })
    },
    qqInit() {
      userAPI.qqInit().then(res => {
        if (res.status === 200) {
          window.location.href = res.data
        }
      })
    },
    sendCode() {
      var phone = this.otpForm.phone
      if (phone === '') {
        this.notifyError('Please enter phone number', null)
        return
      }
      if (this.otpForm.captcha_value === '') {
        this.notifyError('Please enter math captcha answer', null)
        return
      }
      if (this.counting) {
        return
      }
      userAPI
        .sendSMSCode({
          phone: phone,
          captcha_id: this.captchaId,
          captcha_value: this.otpForm.captcha_value
        })
        .then(res => {
          if (res.status === 200) {
            // 发送成功后才启动倒计时
            this.counting = true
            this.codeText = this.totalTime + 's'
            var clock = window.setInterval(() => {
              this.totalTime--
              this.codeText = this.totalTime + 's'
              if (this.totalTime < 0) {
                window.clearInterval(clock)
                this.codeText = 'Get Code'
                this.totalTime = 60
                this.counting = false
              }
            }, 1000)
            // 算式一次性使用,清空并刷新
            this.otpForm.captcha_value = ''
            this.refreshCaptcha()
            this.notifySucceed('Verification code sent')
          } else {
            this.refreshCaptcha()
            this.notifyError('Failed to send code', res.msg)
          }
        })
        .catch(error => {
          this.refreshCaptcha()
          this.notifyError('Failed to send code', error)
        })
    },
    otpLogin(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        userAPI
          .smsLogin(this.otpForm)
          .then(res => {
            if (res.status === 200) {
              // 登录信息存到本地
              let user = JSON.stringify(res.data.user)
              localStorage.setItem('user', user)
              localStorage.setItem('token', res.data.token)
              // 登录信息存到vuex
              this.setUser(res.data.user)
              // 弹出通知框提示登录成功信息
              this.notifySucceed('Login successful')
              this.$router.push({
                name: 'Home'
              })
            } else {
              this.notifyError('Login failed', res.msg)
            }
          })
          .catch(error => {
            this.notifyError('Login failed', error)
          })
      })
    }
  },
  mounted() {
    this.refreshCaptcha()
  },

  components: {}
}
</script>

<style scoped>
@import '../assets/css/button.css';
.text {
  font-size: 14px;
}

.item {
  margin: 0 auto;
  width: 300px;
}

.clearfix {
  font-size: 20px;
  margin-bottom: 20px;
}

.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 300px;
  border-radius: 10px;
}
.login-logo-link {
  display: flex;
  justify-content: center;
}
.login-logo {
  width: 120px;
  height: auto;
}
.box-card .line {
  height: 30px;
  width: 300px;
  margin: 0 auto;
  border-bottom: 1px solid #c0c0c0;
}
/*算式验证码*/
.math-captcha {
  width: 36%;
  float: right;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  color: #757575;
  font-weight: bold;
  user-select: none;
}
.math-captcha:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background: #ecf5ff;
}
/*其他账号登录*/
.box-card .logo {
  width: 300px;
  margin: 0 auto;
  height: 30px;
  display: flex;
  align-items: center;
}
.box-card .logo .logo-info {
  font-size: 14px;
  color: #757575;
}
.box-card .logo .logo-login {
  height: 15px;
  margin-left: 10px;
}
/*其他账号登录END*/
</style>
